import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../app/guards'
import { UnitsPage } from '../../features/catalog/units-page'

export const Route = createFileRoute('/_app/units')({
  staticData: { crumb: 'units' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'products.read'),
  component: UnitsPage,
})
